import React from 'react'
import BaseDateRangeReport from "./BaseDateRangedReport";

export default () => <BaseDateRangeReport
    reportHeader="Settlements Without Authorisations Report"
    reportDownloadName="settlementsWithoutAuthorisationsReport"
    apiReportName="settlementsWithoutAuthorisationsReport"
    downloadOnly={false}
/>
